<div class="container main-layout main-layout-left positionrel diff-layout history-page not-toggle-transcript">
    <div class="right-container">
        <div class="display-flex">
            <div class="float-left">
                <div class="title">
                    <span class="scenario-name">Assigned Roleplay</span>
                    <span class="scenario-name" title="{{history?.scenario_name}}">- {{history?.scenario_name |
                        truncate:15}}</span>
                </div>
            </div>
            <div class="float-right">
                <div class="download-tran">
                    <img src="../../../assets/images/download-new.svg" width="22" height="24"
                        (click)="displayTranscriptAsPdf()" alt="Download Transcript" title="Download Transcript">
                </div>
            </div>
        </div>
        
        <div class="chat-window" #scrollContainer>
            <div class="frame-box" id="chat-box" #scrollMe [scrollTop]="scrollMe.scrollHeight">
                <div *ngFor="let conversation of conversations">
                    <div class="card-text padding">
                        <!-- Coach Response Section -->
                        <div class="coach-side" *ngIf="conversation.coach_used && conversation.question">
                            <div class="profile-container-coach">
                                <img class="profile-img" src="../../../assets/icons/coach-assist.svg"
                                    alt="Coach" title="Coach">
                            </div>
                            <div class="bubble coach-bubble">
                                <div class="time">
                                    <span class="profile-name">Coach</span> at {{conversation.getCurrentQuesAnsTime}}
                                </div>
                                <div class="typewriter">
                                    <p>{{ conversation.question}}</p>
                                </div>
                                <div *ngIf="conversation.coach_references?.length" class="inline-references">
                                    <span class="references-title">References</span>
                                    <ul class="references-list">
                                        <li *ngFor="let ref of conversation.coach_references">
                                            <a class="ref-filename" (click)="openReferenceDocument(ref, $event)" href="javascript:void(0)">{{ ref.FileName }}</a>
                                            <span class="ref-page" *ngIf="ref.page_number"> — Page {{ ref.page_number }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- User Response Section -->
                        <div class="left-side" *ngIf="!conversation.coach_used">
                            <div class="profile-container-ai">
                                <img class="profile-img" src="../../../assets/images/JJMT_Icon_Web_Profile.png"
                                    alt="Profile Image" title="User">
                            </div>
                            <div class="bubble question-bubble">
                                <div class="time">
                                    <span class="profile-name">{{givenName}}</span> at {{conversation.getCurrentQuesAnsTime}}
                                </div>
                                <div class="typewriter">
                                    <p>{{ conversation.question}}</p>
                                </div>
                                <div *ngIf="conversation.bot_last_response" class="view-coach-response" (click)="viewCoachResponse(conversation)"><a title="View coach response">View coach response</a></div>
                            </div>
                        </div>
                        <div class="right-side" *ngIf="(conversation.answer!='')">
                            <div class="profile-container">
                                <img class="profile-img" src="../../../assets/images/chatbot-icon.svg"
                                    alt="Profile Image" title="Ai chat">
                            </div>
                            <div class="bubble answer-bubble-ans">
                                <div class="time-ans">
                                    <span class="profile-name">{{ history?.dr_name }}</span>
                                    at {{conversation.getCurrentQuesAnsTime}}
                                </div>
                                <div class="typewriter">
                                    <markdown class="variable-binding" [data]="conversation.answer"></markdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ff-outer">
                    <div class="feedback-footer">
                        <div class="message-box">
                            <span>You have completed the Roleplay session.</span>
                        </div>
                    </div>
                </div>
                <!-- feedback message start -->
                <div id="feedback-section" *ngIf="chat_session_id">
                    <div class="ff-outer">
                        <div class="feedback-footer">
                            <div class="message-box">
                                <p><a (click)="openFeedbackScreen()">Please click here to view the roleplay feedback</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- feedback message end -->
            </div>
        </div>
    </div>
</div>